// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"205":"2138214a","242":"7474f7a0","667":"f957a80b","794":"d073ebc7","972":"36c191cb"}[chunkId] + ".chunk.js";
};